import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {StoreService} from '../../services/store.service';
import {environment} from 'src/environments/environment';
import {AppDataService} from "../../services/app-data.service";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  issSellMarketplace: boolean = environment.isStoreCloud
  @Output() scrollToTop: EventEmitter<any> = new EventEmitter<any>();
  isShop: any;
  scConfig: boolean = false;
  isSellerHub : any  = '';
  currentYear = new Date().getFullYear();
  protected readonly environment = environment;

  footerLinks: any = [
    {
      iconClass: 'fa-brands fa-square-facebook',
      iconLink: 'https://www.facebook.com/YallaSuperMallEG',
      iconName: 'facebook'
    },{
      iconClass: 'fa-brands fa-square-twitter',
      iconLink: 'https://twitter.com/YallaSuperappEG',
      iconName: 'twitter'
    },{
      iconClass: 'fa-brands fa-youtube',
      iconLink: 'https://www.youtube.com/@yallasuperapp3030',
      iconName: 'youtube'
    },{
      iconClass: 'fa-brands fa-instagram',
      iconLink: 'https://www.instagram.com/yallasupermalleg/',
      iconName: 'instagram'
    },{
      iconClass: 'fa-brands fa-tiktok',
      iconLink: 'https://www.tiktok.com/@yallasupermall',
      iconName: 'tiktok'
    },
  ]

  constructor(private store: StoreService,
              public router: Router,
              private appDataService: AppDataService,
              private authService: AuthService) {
    if (environment.isStoreCloud) {
      this.scConfig = true;
    } else {
      this.scConfig = false;

    }
  }

  ngOnInit(): void {
    if(!this.authService.isMarketplace()){
      const socialLinks = this.appDataService.shopSettingData
      if(socialLinks) {
        for (const link of this.footerLinks) {
          if (socialLinks.hasOwnProperty(link.iconName) && socialLinks[link.iconName] !== null) {
            link.iconUrl = socialLinks[link.iconName];
          }
        }
      }
    }
  }

  reloadCurrentPage(pageId: number, title: string) {

    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
      this.router.navigate(['/about-us/'], {
        queryParams: {pageId: pageId, title: title},
      })
    );
  }

  navigatePage(url: string) {
    this.router
      .navigateByUrl('/', {skipLocationChange: true})
      .then(() => this.router.navigate(['/' + url + '/']));
  }

  ngAfterViewInit(): void {
    setTimeout(() => {

      this.store.subscription('isShop').subscribe({
        next: (res) => (this.isShop = res),
      });
    }, 10);
    this.store.subscription('allowedFeature').subscribe({
      next :(res) => {
        if(res.length){
          this.isSellerHub = localStorage.getItem('isSellerHub')
        }
      }
    })
  }

  backToTop() {


    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    const scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;

      if (pos > 0) {

        window.scrollTo(0, pos - 50);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 10);

    this.scrollToTop.emit();
  }
  navigateToSellerHub() {
    window.open(environment.merchantURL +'?tenantId=' +`${localStorage.getItem('tenantId')}`, '_blank');
  }
}
